import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonImg,
  IonItem,
  IonList,
  IonModal,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import useAPI from "../../hooks/basic/useAPI";
import { useHistory } from "react-router";

function NewMatchModal({ athletes, isOpen, onDidDismiss, booking, creatorId }) {
  const [matchType, setMatchType] = useState("single");
  const [firstTeamFirstAthlete, setFirstTeamFirstAthlete] = useState(null);
  const [firstTeamSecondAthlete, setFirstTeamSecondAthlete] = useState(null);
  const [secondTeamFirstAthlete, setSecondTeamFirstAthlete] = useState(null);
  const [secondTeamSecondAthlete, setSecondTeamSecondAthlete] = useState(null);
  const [matchMode, setMatchMode] = useState("2set_tiebreak");
  const [isPublic, setIsPublic] = useState(false);
  const [isKillerPoint, setIsKillerPoint] = useState(false);
  const { callAPI } = useAPI();
  const history = useHistory();

  useEffect(() => {
    if (athletes.length > 0) {
      setFirstTeamFirstAthlete(athletes[0]);
      if (athletes.length > 1) {
        setSecondTeamFirstAthlete(athletes[1]);
      }
    }
  }, []);

  const selectedAthletes = [
    firstTeamFirstAthlete,
    firstTeamSecondAthlete,
    secondTeamFirstAthlete,
    secondTeamSecondAthlete,
  ].filter(
    (athlete) =>
      athlete !== null &&
      athlete.id !== "ospite_1" &&
      athlete.id !== "ospite_2",
  );

  const validFirstTeamFirstAthletes = athletes.filter(
    (athlete) =>
      firstTeamFirstAthlete?.id === athlete.id ||
      !selectedAthletes.some((a) => a?.id === athlete.id),
  );

  const validFirstTeamSecondAthletes = athletes.filter(
    (athlete) =>
      firstTeamSecondAthlete?.id === athlete.id ||
      !selectedAthletes.some((a) => a?.id === athlete.id),
  );

  const validSecondTeamFirstAthletes = athletes.filter(
    (athlete) =>
      secondTeamFirstAthlete?.id === athlete.id ||
      !selectedAthletes.some((a) => a?.id === athlete.id),
  );

  const validSecondTeamSecondAthletes = athletes.filter(
    (athlete) =>
      secondTeamSecondAthlete?.id === athlete.id ||
      !selectedAthletes.some((a) => a?.id === athlete.id),
  );

  const saveNewMatch = async () => {
    // const { supervisorId, type, mode, bookingId, team_a, team_b } = req.body;
    // url: `/delete-group`,
    //     method: "DELETE",
    //     params: {
    //       id: subscription.id,
    //     },
    const team_a = [
      {
        athleteId: firstTeamFirstAthlete.userId,
        name: firstTeamFirstAthlete.fullName,
      },
      firstTeamSecondAthlete && {
        athleteId: firstTeamSecondAthlete.userId,
        name: firstTeamSecondAthlete.fullName,
      },
    ].filter(Boolean);

    const team_b = [
      {
        athleteId: secondTeamFirstAthlete.userId,
        name: secondTeamFirstAthlete.fullName,
      },
      secondTeamSecondAthlete && {
        athleteId: secondTeamSecondAthlete.userId,
        name: secondTeamSecondAthlete.fullName,
      },
    ].filter(Boolean);

    const matchId = await callAPI({
      url: "/match",
      method: "POST",
      data: {
        supervisorId: creatorId ?? booking?.relatedSupervisorId ?? null,
        type: matchType,
        mode: matchMode,
        bookingId: booking?.id ?? null,
        isPublic,
        enableKillerPoint: isKillerPoint,
        team_a,
        team_b,
      },
    });

    onDidDismiss();
    history.push(`/match/${matchId}`);
  };

  return (
    <IonModal
      className=""
      zIndex="80000"
      style={{ zIndex: 9999 }}
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
    >
      <IonHeader className="no-border">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "env(safe-area-inset-top)", // Aggiunge spazio su iPhone
            textAlign: "center",
          }}
        >
          <IonImg
            src="notification.png"
            style={{
              width: "55px",
              paddingTop: "1rem",
              marginBottom: "0.5rem",
            }}
          />
          <h3
            style={{
              fontWeight: "bold",
              color: "#062a40",
            }}
          >
            Nuova partita
          </h3>
        </div>
      </IonHeader>
      <IonContent className="ion-padding" style={{}}>
        <IonList>
          <IonItem>
            <IonSelect
              label="Tipologia"
              placeholder="Tipologia partita"
              onIonChange={(e) => setMatchType(e.detail.value)}
              value={matchType}
            >
              <IonSelectOption value="single">Singolare</IonSelectOption>
              <IonSelectOption value="double">Doppio</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonSelect
              label={
                matchType === "single"
                  ? "Giocatore 1"
                  : "Squadra A - Giocatore 1"
              }
              placeholder={
                matchType === "single"
                  ? "Giocatore 1"
                  : "Squadra A - Giocatore 1"
              }
              onIonChange={(e) => {
                debugger;
                if (e.detail.value === "ospite_1") {
                  setFirstTeamFirstAthlete({
                    id: "ospite_1",
                    userId: "ospite_1",
                    fullName: "Ospite",
                    nome: "",
                    cognome: "",
                  });
                  return;
                }
                const athlete = athletes.find(
                  (athlete) => athlete.userId === e.detail.value,
                );
                setFirstTeamFirstAthlete(athlete);
              }}
              value={firstTeamFirstAthlete?.userId}
            >
              {validFirstTeamFirstAthletes.map((athlete) => (
                <IonSelectOption key={athlete.userId} value={athlete.userId}>
                  {athlete.fullName}
                </IonSelectOption>
              ))}
              <IonSelectOption value="ospite_1">Ospite</IonSelectOption>
            </IonSelect>
          </IonItem>
          {matchType !== "single" && (
            <IonItem>
              <IonSelect
                label="Squadra A - Giocatore 2"
                placeholder="Squadra A - Giocatore 2"
                onIonChange={(e) => {
                  if (e.detail.value === "ospite_1_2") {
                    setFirstTeamSecondAthlete({
                      id: "ospite_1_2",
                      userId: "ospite_1_2",
                      fullName: "Ospite",
                      nome: "",
                      cognome: "",
                    });
                    return;
                  }
                  const athlete = athletes.find(
                    (athlete) => athlete.userId === e.detail.value,
                  );
                  setFirstTeamSecondAthlete(athlete);
                }}
                value={firstTeamSecondAthlete?.userId}
              >
                {validFirstTeamSecondAthletes.map((athlete) => (
                  <IonSelectOption key={athlete.userId} value={athlete.userId}>
                    {athlete.fullName}
                  </IonSelectOption>
                ))}
                <IonSelectOption value="ospite_1_2">Ospite</IonSelectOption>
              </IonSelect>
            </IonItem>
          )}
          <IonItem>
            <IonSelect
              label={
                matchType === "single"
                  ? "Giocatore 2"
                  : "Squadra B - Giocatore 1"
              }
              placeholder={
                matchType === "single"
                  ? "Giocatore 2"
                  : "Squadra B - Giocatore 1"
              }
              onIonChange={(e) => {
                if (e.detail.value === "ospite_2") {
                  setSecondTeamFirstAthlete({
                    id: "ospite_2",
                    userId: "ospite_2",
                    fullName: "Ospite",
                    nome: "",
                    cognome: "",
                  });
                  return;
                }
                const athlete = athletes.find(
                  (athlete) => athlete.userId === e.detail.value,
                );
                setSecondTeamFirstAthlete(athlete);
              }}
              value={secondTeamFirstAthlete?.userId}
            >
              {validSecondTeamFirstAthletes.map((athlete) => (
                <IonSelectOption key={athlete.userId} value={athlete.userId}>
                  {athlete.fullName}
                </IonSelectOption>
              ))}
              <IonSelectOption value="ospite_2">Ospite</IonSelectOption>
            </IonSelect>
          </IonItem>
          {matchType !== "single" && (
            <IonItem>
              <IonSelect
                label="Squadra B - Giocatore 2"
                placeholder="Squadra B - Giocatore 2"
                onIonChange={(e) => {
                  if (e.detail.value === "ospite_2_2") {
                    setSecondTeamSecondAthlete({
                      id: "ospite_2_2",
                      userId: "ospite_2_2",
                      fullName: "Ospite",
                      nome: "",
                      cognome: "",
                    });
                    return;
                  }
                  const athlete = athletes.find(
                    (athlete) => athlete.userId === e.detail.value,
                  );
                  setSecondTeamSecondAthlete(athlete);
                }}
                value={secondTeamSecondAthlete?.userId}
              >
                {validSecondTeamSecondAthletes.map((athlete) => (
                  <IonSelectOption key={athlete.userId} value={athlete.userId}>
                    {athlete.fullName}
                  </IonSelectOption>
                ))}
                <IonSelectOption value="ospite_2_2">Ospite</IonSelectOption>
              </IonSelect>
            </IonItem>
          )}
          <IonItem>
            <IonSelect
              label="Modalità"
              placeholder="Modalità"
              onIonChange={(e) => setMatchMode(e.detail.value)}
              value={matchMode}
            >
              <IonSelectOption value="2set_tiebreak">
                2 set + tie break
              </IonSelectOption>
              <IonSelectOption value="1set">1 set</IonSelectOption>
              <IonSelectOption value="1setTC">1 set Team Cup</IonSelectOption>
              <IonSelectOption value="best_of_3">
                Al meglio di 3
              </IonSelectOption>
              <IonSelectOption value="best_of_5">
                Al meglio di 5
              </IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonSelect
              label="Killer point"
              onIonChange={(e) => {
                setIsKillerPoint(e.detail.value === "true");
              }}
              value={isKillerPoint ? "true" : "false"}
            >
              <IonSelectOption value="true">Sì</IonSelectOption>
              <IonSelectOption value="false">No</IonSelectOption>
            </IonSelect>
          </IonItem>
          <IonItem>
            <IonSelect
              label="Condivisione"
              onIonChange={(e) => {
                setIsPublic(e.detail.value === "public");
              }}
              value={isPublic ? "public" : "private"}
            >
              <IonSelectOption value="public">Pubblico</IonSelectOption>
              <IonSelectOption value="private">Privato</IonSelectOption>
            </IonSelect>
          </IonItem>
        </IonList>
      </IonContent>
      <IonFooter className="no-border ion-padding">
        <IonButton
          className="ion-margin-bottom"
          expand="block"
          size="large"
          color="success"
          onClick={saveNewMatch}
        >
          Crea
        </IonButton>
        <IonButton
          expand="block"
          size="large"
          color="danger"
          onClick={onDidDismiss}
        >
          Annulla
        </IonButton>
      </IonFooter>
    </IonModal>
  );
}

NewMatchModal.propTypes = {
  athletes: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onDidDismiss: PropTypes.func.isRequired,
  booking: PropTypes.object.isRequired,
  creatorId: PropTypes.string,
};

export default NewMatchModal;
